import React from "react";
import PageHeader from "../../components/common/PageHeader";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import ServicesHeroSection from "../../components/Our Service/ServicesHeroSection";

const ServicesDetails = () => {
  return (
    <div>
      <PageHeader title="Services" />
      <ServicesHeroSection />
      <LatestServiceOffer />
    </div>
  );
};

export default ServicesDetails;
